import {errorHandler} from "./common";
import EventBus from "./event-bus";
const axios = require('axios');

export function getGood(id) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit("showLoading", true);
    let url = process.env.ROOT_API + 'admin/good?id='+id;


    axios.get(url,  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      EventBus.$emit("showLoading", false);
      errorHandler(err);
      reject(err);
    })
  })
}
export function getGoods(type , requestId = 0, orderBy = null) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit("showLoading", true);
    let url = process.env.ROOT_API + 'admin/goods?type=' + type + "&requestId="+requestId;

    if(orderBy != null) {
      url += "&orderBy="+orderBy;
    }
    console.log("get goods list " + url);
    axios.get(url,  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      EventBus.$emit("showLoading", false);
      errorHandler(err);
      reject(err);
    })
  })
}
export function updateGood(good) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit("showLoading", true);
    axios.post(process.env.ROOT_API + 'admin/good', JSON.stringify(good),  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      EventBus.$emit("showLoading", false);
      errorHandler(err);
      reject(err);
    })
  })
}
export function updateGoods(goods) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit("showLoading", true);
    axios.post(process.env.ROOT_API + 'admin/goods', JSON.stringify(goods),  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      EventBus.$emit("showLoading", false);
      errorHandler(err);
      reject(err);
    })
  })
}
export function deleteGood(id) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit("showLoading", true);
    axios.delete(process.env.ROOT_API + 'admin/good?id='+ id,  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      EventBus.$emit("showLoading", false);
      errorHandler(err);
      reject(err);
    })
  })
}
export function getGoodsTemplates(type, orderBy = null) {
  return new Promise(function(resolve, reject) {
    let url = process.env.ROOT_API+'web/goods/templates?type='+type;
    if(orderBy != null) {
      url += '&orderBy=' + orderBy;
    }
    axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
      }

    })
      .then(function(response) {
        let data = response.data;
        resolve(data);
      })
      .catch(function(err){
        reject(err);
      })
  })

}
export function createNewGoodItem(requestId, type) {
  let item = {
    id:0,
    title:'',
    location:'',
    size:'',
    amount:0,
    type:type,
    requestId:requestId,
    pos:0,
    min:1,
    max:10,
    gap:1,
    volume:1,
    parentId:0,
    removal:false,

  }
  return item;
}
export function getGoodSizeList() {
  let list = [
    {
      title: 'S',
      value: 'small',
    },
    {
      title: 'M',
      value: 'medium',
    },
    {
      title: 'L',
      value: 'large',
    },
  ];

  return list;
}
export function getLocationList() {
  let list = [
    {
      title:'Living Room',
      value:'Living Room',
    },
    {
      title:'Dining Room',
      value:'Dining Room',
    },
    {
      title:'Kitchen',
      value:'Kitchen',
    },
    {
      title:'Master Bed Room',
      value:'Master Bed Room',
    },
    {
      title:'Room1',
      value:'Room1',
    },
    {
      title:'Room2',
      value:'Room2',
    },
    {
      title:'Room3',
      value:'Room3',
    },
    {
      title:'Garage',
      value:'Garage',
    },
    {
      title:'Others',
      value:'Others',
    }
  ];
  return list;
}
export function getPreparationItemList() {
  let list = [
    {
      title:'책 박스',
      value:'book_box',
    },
    {
      title:'그릇 박스',
      value:'dish_box',
    },
    {
      title:'4 C',
      value:'4_c',
    },
    {
      title:'FLAT 박스',
      value:'flat_box',
    },
    {
      title:'골프 박스',
      value:'golf_box',
    },
    {
      title:'행거 박스',
      value:'hanger_box',
    },
    {
      title:'중고 박스',
      value:'second_box',
    },
    {
      title:'가구 속지',
      value:'furniture_paper',
    },
    {
      title:'에어 캡',
      value:'air_cap',
    },
    {
      title:'종이',
      value:'paper',
    },
    {
      title:'매트리스 커버',
      value:'mattress_cover',
    },
    {
      title:'시트 보드',
      value:'sheet_board',
    },
    {
      title:'TAPE',
      value:'tape',
    },

  ]

  return list;
}



// WEBPACK FOOTER //
// ./src/api/goods.js